import { formatDateToIsoString } from "@/helpers/helpers";

export default {
  requestQueryParams() {
    const params = new URLSearchParams();

    if (this.filters.keyword !== "" && this.filters.keyword !== null) {
      params.set("keyword", this.filters.keyword);
    }

    if (this.filters.advanced.cycle !== null) {
      params.set("cycle", this.filters.advanced.cycle);
    }

    if (this.filters.advanced.status.length > 0) {
      this.filters.advanced.status.forEach((element) =>
        params.append("status", element)
      );
    }

    if (this.filters.advanced.branch !== null) {
      params.set("branch", this.filters.advanced.branch);
    }

    if (this.filters.advanced.projects.length > 0) {
      this.filters.advanced.projects.forEach((element) =>
        params.append("projects", element)
      );
    }

    if (this.filters.advanced.sections.length > 0) {
      this.filters.advanced.sections.forEach((element) =>
        params.append("sections", element)
      );
    }

    if (this.filters.advanced.thematicAreas.length > 0) {
      this.filters.advanced.thematicAreas.forEach((element) =>
        params.append("thematicAreas", element)
      );
    }

    if (this.filters.advanced.types.length > 0) {
      this.filters.advanced.types.forEach((element) =>
        params.append("types", element)
      );
    }

    if (
      this.filters.advanced.startDates != null &&
      this.filters.advanced.startDates.length > 0
    ) {
      const stStartDate = this.filters.advanced.startDates[0];
      const stEndDate = this.filters.advanced.startDates.at(-1);
      params.set("stStartDate", formatDateToIsoString(new Date(stStartDate)));
      params.set("stEndDate", formatDateToIsoString(new Date(stEndDate)));
    }

    if (
      this.filters.advanced.endDates != null &&
      this.filters.advanced.endDates.length > 0
    ) {
      const enStartDate = this.filters.advanced.endDates[0];
      const enEndDate = this.filters.advanced.endDates.at(-1);
      params.set("enStartDate", formatDateToIsoString(new Date(enStartDate)));
      params.set("enEndDate", formatDateToIsoString(new Date(enEndDate)));
    }

    if (
      this.filters.advanced.regDates != null &&
      this.filters.advanced.regDates.length > 0
    ) {
      const regStartDate = this.filters.advanced.regDates[0];
      const regEndDate = this.filters.advanced.regDates.at(-1);
      params.set("regStartDate", formatDateToIsoString(new Date(regStartDate)));
      params.set("regEndDate", formatDateToIsoString(new Date(regEndDate)));
    }

    return params;
  },
};
